import {
    ActionType,
    registerCareCommentAction
} from "./actions";
import { createSlice } from "@reduxjs/toolkit";
import { CareCommentJson } from "../../../../domain/care_comment/CareComment";

export type AdminCareCommentState = Readonly<{
    careComment: CareCommentJson | null,
    registerSucceeded: boolean,
    registerFailed: boolean,
    processing: number
}>;

const careCommentInitialState: AdminCareCommentState = {
    careComment: null,
    registerSucceeded: false,
    registerFailed: false,
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: careCommentInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                registerCareCommentAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                registerCareCommentAction.fulfilled,
                (state, action) => {
                    state.careComment = action.payload.carecomment;
                    state.processing -= 1;
                }
            )
            .addCase(
                registerCareCommentAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const adminCareCommentReducer = slice.reducer;
